<div class="total-price">
  <div>
    <div class="total-title">
      {{ "modeso_cart_cart_cart-total_summary-total-sum" | injectedText | async }}
    </div>
    <div class="total-desc">
      {{ "modeso_cart_cart_cart-total_summary-total-vat" | injectedText | async }}
    </div>
  </div>
  <div id="cartTotalPrice" class="total-price">CHF {{getTotalPrice() | number : '1.2'}}</div>
</div>